import styled, { css } from 'styled-components'
import { getResponsiveStyles } from 'styles/mixins'
import { ResponsiveSize } from 'styles/types'
import { rotateSequence } from 'styles/animations'
import ImageLoader from 'assets/icons/image_loader.svg'

interface ImageWrapperProps {
    width?: ResponsiveSize
    height?: ResponsiveSize
    borderRadius?: number
    isLoaded?: boolean
    isError?: boolean
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
    position: relative;
    flex-shrink: 0;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.grayscale_400};
    ${({ width }) => width && getResponsiveStyles(width, 'width')}
    ${({ height }) => height && getResponsiveStyles(height, 'height')}
    ${({ borderRadius }) =>
        borderRadius &&
        css`
            border-radius: ${borderRadius}px;
        `}

    // spinning loader for no-loaded images
    ${({ isLoaded }) =>
        !isLoaded &&
        css`
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                width: 100%;
                height: 100%;
                background-color: ${({ theme }) => theme.colors.grayscale_400};
            }
            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                width: 100%;
                height: 100%;
                background-image: url(${ImageLoader});
                background-position: center;
                background-repeat: no-repeat;
                background-size: auto;
                animation: ${rotateSequence} 1s linear infinite;
            }
        `}

    img {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        object-fit: ${({ isError }) => (isError ? 'none' : 'cover')};
    }
`
